import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';

import { videoExtensions } from '@shared/constants/file-extensions.const';

@Directive({
  standalone: true,
  selector: '[appIsVideo]',
})
export class IsVideoDirective implements OnInit {
  private templateRef: TemplateRef<any> = inject(TemplateRef);
  private vcr: ViewContainerRef = inject(ViewContainerRef);

  private show = false;

  @Input() set appIsVideo(value: string | { cloudUri: string; thumbnailFileUploadCloudUri?: string }) {
    this.show = this.checkIfVideo(value);
    this.displayTemplate();
  }

  @Input() appIsVideoElse?: TemplateRef<unknown>;

  ngOnInit(): void {
    this.displayTemplate();
  }

  private displayTemplate(): void {
    this.vcr.clear();
    if (this.show) {
      this.vcr.createEmbeddedView(this.templateRef);
    } else if (this.appIsVideoElse) {
      this.vcr.createEmbeddedView(this.appIsVideoElse);
    }
  }

  private checkIfVideo(value: string | { cloudUri: string; thumbnailFileUploadCloudUri?: string }): boolean {
    if (typeof value === 'object') {
      if (value.thumbnailFileUploadCloudUri) return true; // as of v6.1.4.7 we have thumbs only for videos
      return this.checkExtension(value.cloudUri);
    }

    return this.checkExtension(value);
  }

  private checkExtension(url: string): boolean {
    const extension = this.getFileExtension(url);
    return videoExtensions.includes(extension);
  }

  private getFileExtension(url: string): string {
    const match = url.match(/\.[^\.]+$/);
    return match ? match[0].toLowerCase() : '';
  }
}
